export enum FEATURE_GATES {
  GALLERY_QUICK_VIEW_MODAL_ENABLED = 'gallery_quick_view_modal_enabled',
}
